
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/pdf",
      function () {
        return require("private-next-pages/admin/pdf/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/pdf"])
      });
    }
  